import { render, staticRenderFns } from "./tip.vue?vue&type=template&id=1789425e&scoped=true"
import script from "./tip.vue?vue&type=script&lang=js"
export * from "./tip.vue?vue&type=script&lang=js"
import style0 from "./tip.vue?vue&type=style&index=0&id=1789425e&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1789425e",
  null
  
)

export default component.exports